import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@quebon/ui/components/tabs'
import { useLcTrialProgram } from '@/hooks/admin/useLcTrialProgram'
import { useAuthStore } from '@/store/authStore'
import { hasLcPermission } from '@/utils/roleUtils'
import TimeslotManagement from './TimeslotManagement'
import ClassRosterSearchPanel from './components/ClassRosterSearchPanel'

/** 클래스 관리 = 클래스 카드 목록 + 센터 전체 현재 원생 목록. */
export default function ClassManagement() {
  const { user } = useAuthStore()
  const { t } = useTranslation('admin')
  const navigate = useNavigate()

  const canManageClasses = hasLcPermission(user ?? undefined, 'CLASS')
  const canReEnroll = canManageClasses && hasLcPermission(user ?? undefined, 'STUDENT')
  const { data: trialProgram } = useLcTrialProgram(canManageClasses)
  const trialEnabled = trialProgram?.enabled === true
  const [activeView, setActiveView] = useState('classes')

  const trialAnalyticsAction = canManageClasses && trialEnabled ? (
    <button
      type="button"
      onClick={() => navigate('/admin/free-trials')}
      className="whitespace-nowrap rounded-lg border border-primary-200 bg-primary-50 px-3 py-2 text-sm font-semibold text-primary-700 hover:bg-primary-100"
    >
      {t('trialAnalytics.openButton')}
    </button>
  ) : null

  return (
    <div>
      {canManageClasses ? (
        <>
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">{t('classes.title')}</h1>
            <p className="mt-1 text-gray-500">{t('classes.subtitle')}</p>
          </div>
          <Tabs value={activeView} onValueChange={setActiveView} className="gap-6">
            <TabsList
              variant="line"
              aria-label={t('classes.viewLabel')}
              className="h-10 w-full justify-start gap-2 rounded-none border-b border-gray-200 p-0"
            >
              <TabsTrigger value="classes" className="h-10 flex-none rounded-none px-4 py-2 after:bottom-0">
                {t('classes.timeslotsTab')}
              </TabsTrigger>
              <TabsTrigger value="learners" className="h-10 flex-none rounded-none px-4 py-2 after:bottom-0">
                {t('classes.enrollmentsTab')}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="classes" keepMounted>
              <TimeslotManagement
                trialEnabled={trialEnabled}
                headerActions={trialAnalyticsAction}
                canReEnroll={canReEnroll}
              />
            </TabsContent>
            <TabsContent value="learners" keepMounted>
              <ClassRosterSearchPanel trialEnabled={trialEnabled} active={activeView === 'learners'} />
            </TabsContent>
          </Tabs>
        </>
      ) : null}
    </div>
  )
}
